import { useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import { Button, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import NotificationsList from "../../features/manageNotifications/notificationsList";
import AddIcon from '@mui/icons-material/Add';
import React from "react";

const ManageNotifications = () => {

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [type, setType] = React.useState('default');

  const handleTypeChange = (event: SelectChangeEvent) => {
    setType(event.target.value as string);
  };

  return (
    <>
      <div className="main_title">
        <h1>Notification & Communication Center</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          Notification & Communication Center
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            />
            <div className="form">
              <div className="control_group">
                <Select
                  fullWidth
                  value={type}
                  onChange={handleTypeChange}
                >
                  <MenuItem disabled value="default">Select Type</MenuItem>
                  <MenuItem value="broadcast">Broadcast</MenuItem>
                  <MenuItem value="email">Email</MenuItem>
                </Select>
              </div>
            </div>
          </div>
          <div className="right_s">
            <Button className="btn btn_primary" onClick={() => navigate("/manage-notifications/add")}><AddIcon /> Add Notification</Button>
          </div>
        </div>

        <NotificationsList />
      </div>
    </>
  );
};

export default ManageNotifications;
